import{Z as o,d as s}from"./p-DOpzuW8T.js";const p=o;const t=s;export{p as ZprLabel,t as defineCustomElement};
//# sourceMappingURL=zpr-label.js.map